export const languageOptions =
    [
        { key: "English", text: "English", value: "en" },
        { key: "Spanish", text: "Española", value: "es" },
        { key: "Deutsch", text: "Deutsch", value: "de" },
        { key: "Portuguese", text: "Portuguese", value: "pt" },
        { key: "Danish", text: "Danish", value: "da" },
        { key: "Finnish", text: "Finnish", value: "fi" },
        { key: "Norwegian", text: "Norwegian", value: "no" },
        { key: "Svenska", text: "Swedish - Sweden", value: "sv" },
        { key: "Dutch", text: "Dutch", value: "nl" },
        { key: "French", text: "French", value: "fr" },
        { key: "Italiano", text: "Italian", value: "it" },
        { key: "Czech", text: "Czech Republic", value: "cz" },
        { key: "Slovakia", text: "Slovakia", value: "sk" },
        { key: "Polish", text: "Polish", value: "pl" },
        { key: "Lithuanian", text: "Lithuania", value: "lt" },
        { key: "Latvian", text: "Latvia", value: "lv" },
        { key: "Estonian", text: "Estonia", value: "et" },
        { key: "Nynorsk", text: "Nynorsk", value: "nn" },
        { key: "Swedish", text: "Swedish", value: "sw" },
    ];
